var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.activeClass],attrs:{"disabled":!_vm.hasRefinements},on:{"click":function($event){$event.preventDefault();return _vm.resetAll($event)}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }